import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "product-card-price__original"
}

import useContext from '@/composables/useContext';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCardPrice',
  props: {
    currentPrice: null,
    originalPrice: null
  },
  setup(__props: any) {



const { formatPrice } = useContext();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-card-price", { 'product-card-price--discounted': __props.originalPrice }])
  }, [
    _createTextVNode(_toDisplayString(_unref(formatPrice)(__props.currentPrice)) + " ", 1),
    (__props.originalPrice)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(formatPrice)(__props.originalPrice)), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})